import Vue from "vue";
import Config from "../configuration";

export default {
    namespaced: true,
    mutations: {

    },
    getters: {

    },
    actions: {
        getFactoringReport (context, payload)
        {
            let self = this;

            return new Promise(function (resolve, reject)
            {
                Vue.axios.put(Config.GetUrl(Config.kritaApi) + 'factoring/' , {ClaimantId: self.state.userInfo.SelectedClaimant.ClaimantId, Current :payload.page, RowCount: payload.rowsPerPage, Sort: payload.sort, Selection: payload.selection, CreatedFrom: payload.createdFrom, CreatedTo: payload.createdTo, FactoringDueDateFrom: payload.dueFrom, FactoringDueDateTo: payload.dueTo, Search: payload.search}, {
                }).then(function (response)
                {
                    if (response.data.HasError)
                    {
                        reject(new Error('no results'));
                    }
                    else
                    {
                        resolve(response.data.Data);
                    }
                }, () =>
                {
                    reject(new Error('no results'));
                });
            });
        },
        getFactoringDetail (context, payload)
        {
            return new Promise(function (resolve, reject)
            {
                Vue.axios.get(Config.GetUrl(Config.kritaApi) + 'factoring/' +  payload.id,{
                }).then(function (response)
                {
                    if (response.data.HasError)
                    {
                        reject(new Error('no results'));
                    }
                    else
                    {
                        resolve(response.data.Data);
                    }
                }, () =>
                {
                    reject(new Error('no results'));
                });
            });
        },
        getPaymentsForFactoringDetail (context, payload)
        {
            let self = this;

            return new Promise(function (resolve, reject)
            {
                Vue.axios.put(Config.GetUrl(Config.kritaApi) + 'factoring/' + payload.id + '/Payments', { Current :payload.page, RowCount: payload.rowsPerPage, Sort: payload.sort, FactoringId:null}, {
                }).then(function (response)
                {
                    if (response.data.HasError)
                    {
                        reject(new Error('no results'));
                    }
                    else
                    {
                        resolve(response.data.Data);
                    }
                }, () =>
                {
                    reject(new Error('no results'));
                });
            });
        },
        getBufferAllocationsForFactoringDetail (context, payload)
        {
            let self = this;

            return new Promise(function (resolve, reject)
            {
                Vue.axios.put(Config.GetUrl(Config.kritaApi) + 'factoring/' + payload.id + '/BufferAllocation', {Current :payload.page, RowCount: payload.rowsPerPage, Sort: payload.sort, FactoringId:null}, {
                }).then(function (response)
                {
                    if (response.data.HasError)
                    {
                        reject(new Error('no results'));
                    }
                    else
                    {
                        resolve(response.data.Data);
                    }
                }, () =>
                {
                    reject(new Error('no results'));
                });
            });
        },
    }
}
